import Icon from 'components/Shared/Icon';
import { PureComponent } from 'react';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './styles.scss';

interface OwnProps {
  type: 'left' | 'right';
  className?: string;
  onClick: (e: React.MouseEvent) => void;
}

export const ControlButton = (props: OwnProps) => {
  const { type, ...attributes } = props;
  const iconAppearance = type === 'left' ? 'flip-180' : 'normal';
  return (
    <button {...attributes}>
      <Icon icon="icon-tall-arrow" appearance={iconAppearance} size="tiny" />
    </button>
  );
};

interface PrevNextControlsProps {
  onPrevious: (e: React.MouseEvent) => void;
  onNext: (e: React.MouseEvent) => void;
  className?: string;
}

export class PrevNextControls extends PureComponent<PrevNextControlsProps> {
  public render() {
    const { className, onPrevious, onNext } = this.props;
    return (
      <div className={className}>
        <ControlButton
          type="left"
          onClick={onPrevious}
          className={styles.prevNextControls}
          {...getQaDataAttr('carousel-prev')}
        />
        <ControlButton
          type="right"
          onClick={onNext}
          className={styles.prevNextControls}
          {...getQaDataAttr('carousel-next')}
        />
      </div>
    );
  }
}
